module.exports = __webpack_public_path__ + "img/apple_us.c548c322.png";